import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Heart, Calendar, ShoppingBag, MessageCircle, Share2,
  User, Sparkles, X, LogIn,
} from 'lucide-react';

const ICONS = {
  book: Calendar,
  favorite: Heart,
  checkout: ShoppingBag,
  chat: MessageCircle,
  share: Share2,
  profile: User,
  generic: Sparkles,
};

const SignUpPromptModal = ({
  open,
  onClose,
  title = 'Sign up to continue',
  message = 'Create a free Skytone account to view your profile, orders, and calendar.',
  ctaLabel = 'Create Account',
  icon = 'generic',
}) => {
  const navigate = useNavigate();
  if (!open) return null;

  const Icon = ICONS[icon] || Sparkles;

  const goRegister = () => {
    onClose?.();
    navigate('/register');
  };

  const goPro = () => {
    onClose?.();
    navigate('/register', { state: { role: 'professional' } });
  };

  const goLogin = () => {
    onClose?.();
    navigate('/login');
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-3xl max-w-sm w-full p-6 relative shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 rounded-full bg-[#FCF8F9] flex items-center justify-center text-gray-400 hover:text-gray-900 transition-colors"
        >
          <X size={16} />
        </button>

        <div className="flex justify-center mb-4">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#FFF5F6] to-[#F4EEFF] flex items-center justify-center relative">
            <div className="absolute inset-0 rounded-full bg-[#EFA9B6]/20 blur-xl"></div>
            <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center shadow-sm relative">
              <Icon size={24} className="text-[#EFA9B6]" />
            </div>
          </div>
        </div>

        <h2 className="font-serif font-bold text-xl text-gray-900 text-center mb-2">
          {title}
        </h2>
        <p className="text-sm text-gray-500 text-center leading-relaxed mb-6">
          {message}
        </p>

        <div className="space-y-2">
          {/* Client signup */}
          <button
            onClick={goRegister}
            className="w-full py-3.5 rounded-full bg-[#010101] text-white font-bold text-sm hover:bg-black/90 active:scale-[0.98] transition-all"
          >
            {ctaLabel}
          </button>

          {/* Go Pro */}
          <button
            onClick={goPro}
            className="w-full py-3.5 rounded-full bg-[#8B5FBF] text-white font-bold text-sm hover:bg-[#7A4EAD] active:scale-[0.98] transition-all flex items-center justify-center gap-2"
          >
            Go Pro
          </button>

          {/* Not now */}
          <button
            onClick={onClose}
            className="w-full py-3 rounded-full bg-white text-gray-600 font-bold text-sm border border-gray-100 hover:bg-gray-50 transition-colors"
          >
            Not now
          </button>
        </div>

        <p className="text-center text-xs text-gray-400 mt-5">
          Already have an account?{' '}
          <button
            onClick={goLogin}
            className="font-bold text-[#EFA9B6] hover:underline inline-flex items-center gap-1"
          >
            <LogIn size={11} />
            Log In
          </button>
        </p>
      </div>
    </div>
  );
};

export default SignUpPromptModal;